// Generated by LiveScript 1.6.0
var SYMBOL, mark, isComputed, purgeKey, setDependents, getDependents, removeDependents, bumpVersion, isCurrent;
SYMBOL = Symbol['for']('@en/computed');
mark = function(fn){
  Object.defineProperty(fn, SYMBOL, {
    value: true,
    enumerable: false,
    configurable: true,
    writable: false
  });
  return fn;
};
isComputed = function(it){
  return typeof it === 'function' && it[SYMBOL] === true;
};
purgeKey = function(depMap, key){
  return depMap.forEach(function(list, depKey){
    var remaining, i$, to$, i;
    remaining = [];
    for (i$ = 0, to$ = list.length; i$ < to$; ++i$) {
      i = i$;
      if (list[i].key !== key) {
        remaining.push(list[i]);
      }
    }
    if (remaining.length === 0) {
      return depMap['delete'](depKey);
    } else if (remaining.length < list.length) {
      return depMap.set(depKey, remaining);
    }
  });
};
setDependents = function(ctx, value, key, parent, prop){
  var e, dep;
  purgeKey(ctx.deps.depMap, key);
  ctx.deps.isEvaluating = true;
  ctx.deps.currentSet.clear();
  try {
    value();
  } catch (e$) {
    e = e$;
  }
  ctx.deps.isEvaluating = false;
  dep = {
    key: key,
    computed: value,
    parent: parent,
    prop: prop
  };
  ctx.deps.currentSet.forEach(function(depKey){
    var list;
    list = ctx.deps.depMap.get(depKey) || [];
    list.push(dep);
    return ctx.deps.depMap.set(depKey, list);
  });
  return ctx.deps.currentSet.clear();
};
getDependents = function(ctx, changedKey){
  var result, seen, dot;
  result = [];
  seen = new Set;
  dot = changedKey + ".";
  ctx.deps.depMap.forEach(function(list, k){
    var i$, to$, i, dep, results$ = [];
    if (k === changedKey || k.startsWith(dot) || changedKey.startsWith(k + ".")) {
      for (i$ = 0, to$ = list.length; i$ < to$; ++i$) {
        i = i$;
        dep = list[i];
        if (!seen.has(dep.computed)) {
          seen.add(dep.computed);
          results$.push(result.push(dep));
        }
      }
      return results$;
    }
  });
  return result;
};
removeDependents = function(ctx, key){
  ctx.deps.depMap['delete'](key);
  return purgeKey(ctx.deps.depMap, key);
};
bumpVersion = function(ctx, key){
  var v;
  v = (ctx.deps.versions.get(key) || 0) + 1;
  ctx.deps.versions.set(key, v);
  return v;
};
isCurrent = function(ctx, key, version){
  return ctx.deps.versions.get(key) === version;
};
module.exports = {
  mark: mark,
  isComputed: isComputed,
  setDependents: setDependents,
  getDependents: getDependents,
  removeDependents: removeDependents,
  purgeKey: purgeKey,
  bumpVersion: bumpVersion,
  isCurrent: isCurrent
};